import {create} from 'zustand';

type FacePhotoState = {
	frontFace: string;
	rightFace: string;
	leftFace: string;
	setFrontFace: (file: string) => void;
	setRightFace: (file: string) => void;
	setLeftFace: (file: string) => void;
	reset: () => void;
};

export const useFacePhotoStore = create<FacePhotoState>(set => ({
	frontFace: '',
	rightFace: '',
	leftFace: '',
	setFrontFace: file => set({frontFace: file}),
	setRightFace: file => set({rightFace: file}),
	setLeftFace: file => set({leftFace: file}),
	reset: () => set({frontFace: '', rightFace: '', leftFace: ''}),
}));
